import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AdminRolView } from "./view/adminRol.view";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React, { useEffect, useState } from "react";
import { useRolesData } from "./hooks/useRolesData";
import { usePagination } from "./hooks/usePagination";
import { EditAddPermission } from "./resources/permission/editAddPermission";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import showToast from "../../services/toast";
import { usePermissionData } from "./hooks/usePermissionData";
import { CreateRoll } from "./resources/createRoll/createRol";
import { datoForm } from "./constanst/adminRolesDTO";
import { useCreateOrEditRol } from "./hooks/useCreateOrEditRol";
import { useRolSuccessHandlers } from "./hooks/useRolSuccessHandlers";
import { useRolErrorHandling } from "./hooks/useRolErrorHandling";
import { useAssignPermissionsToRol } from "./hooks/useAssignPermissionsToRol";
import { useRolOptionsMenu } from "./hooks/useRolOptionsMenu";
export var RolAdmin = function () {
    var _a = useState(false), openDrawer = _a[0], setOpenDrawer = _a[1];
    var _b = useState(false), openMadalEdit = _b[0], setOpenModalEdit = _b[1];
    var _c = useState(false), openMadalCreate = _c[0], setOpenModalCreate = _c[1];
    var _d = useState([]), permissionsRows = _d[0], setPermissionsRows = _d[1];
    var _e = useState([]), filtersApplied = _e[0], setFiltersApplied = _e[1];
    var _f = useState(datoForm), dataFormRoles = _f[0], setDataFormRoles = _f[1];
    var _g = useState([]), assignedPermissions = _g[0], setAssignedPermissions = _g[1];
    var _h = useState(""), rolName = _h[0], setRolName = _h[1];
    var _j = useState(""), rolId = _j[0], setRolId = _j[1];
    var _k = useState(""), rolDescription = _k[0], setRolDescription = _k[1];
    var _l = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _l[0], setSeeToast = _l[1];
    // Hooks de datos
    var _m = useRolesData(filtersApplied), rolesData = _m.rolesData, loadingRol = _m.loadingRol, countData = _m.countData, limit = _m.limit, page = _m.page, setLimit = _m.setLimit, setPage = _m.setPage, callRoles = _m.callRoles, setSearchQuery = _m.setSearchQuery;
    var _o = usePagination(setPage, setLimit, callRoles), onChangePage = _o.onChangePage, onChangeLimit = _o.onChangeLimit;
    var _p = usePermissionData(), permissionList = _p.permissionList, loadingPermission = _p.loadingPermission;
    // Hook para crear/editar rol
    var _q = useCreateOrEditRol(rolId), isEdit = _q.isEdit, setIsEdit = _q.setIsEdit, handleSubmitRol = _q.handleSubmitRol, resetTriggers = _q.resetTriggers, loadingRolPost = _q.loadingRolPost, loadingRolPatch = _q.loadingRolPatch, errorRolPost = _q.errorRolPost, errorRolPatch = _q.errorRolPatch, responseRolPost = _q.response;
    // Hook para asignar permisos a rol
    var _r = useAssignPermissionsToRol({
        rolId: rolId,
        rolName: rolName,
        rolDescription: rolDescription,
    }), handleAssignPermissions = _r.handleAssignPermissions, resetPermissionTrigger = _r.resetTrigger, loadingAssignPermissions = _r.loading, errorAssignPermissions = _r.error, responseAssignPermissions = _r.response;
    // Hook para manejar opciones de la card
    var onOptionsCardClick = useRolOptionsMenu({
        setIsEdit: setIsEdit,
        setRolId: setRolId,
        setOpenModalCreate: setOpenModalCreate,
        setDataFormRoles: setDataFormRoles,
        setRolName: setRolName,
        setRolDescription: setRolDescription,
        setPermissionsRows: setPermissionsRows,
        setAssignedPermissions: setAssignedPermissions,
        setOpenDrawer: setOpenDrawer,
    }).onOptionsCardClick;
    // Hook para manejar éxitos al crear/editar rol
    var handleRolSubmitSuccess = useRolSuccessHandlers({
        isEdit: isEdit,
        setSeeToast: setSeeToast,
        setOpenModalCreate: setOpenModalCreate,
        resetTriggers: resetTriggers,
        callRoles: callRoles,
    }).handleRolSubmitSuccess;
    useRolErrorHandling({
        errorRolPost: errorRolPost,
        errorRolPatch: errorRolPatch,
        errorAssignPermissions: errorAssignPermissions,
        setSeeToast: setSeeToast,
    });
    useEffect(function () {
        if (responseRolPost) {
            handleRolSubmitSuccess();
        }
    }, [responseRolPost, handleRolSubmitSuccess]);
    useEffect(function () {
        if (responseAssignPermissions) {
            setSeeToast({
                show: true,
                message: "Permisos asignados con éxito",
                type: typeAlert.success,
            });
            setOpenModalEdit(false);
            setOpenDrawer(false);
            resetPermissionTrigger();
            callRoles(true);
        }
    }, [responseAssignPermissions, resetPermissionTrigger, callRoles]);
    var handleOpenCreateModal = function () {
        setIsEdit(false);
        setRolId("");
        setDataFormRoles(datoForm);
        setOpenModalCreate(true);
    };
    var loading = loadingRol ||
        loadingPermission ||
        loadingRolPost ||
        loadingRolPatch ||
        loadingAssignPermissions;
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loading, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: isEdit ? "Actualizando rol..." : "Creando rol..." }), _jsx(CreateRoll, { openModal: openMadalCreate, setOpenModal: setOpenModalCreate, dataFormRoles: dataFormRoles, setDataFormRoles: setDataFormRoles, isEdit: isEdit, onSubmit: handleSubmitRol }), _jsx(EditAddPermission, { openMadalEdit: openMadalEdit, setOpenModalEdit: setOpenModalEdit, rolName: rolName, assignedPermission: assignedPermissions, PermissionList: permissionList, rolId: rolId, handleAssignPermissions: handleAssignPermissions }), _jsx(AdminRolView, { onOptionsCardClick: onOptionsCardClick, openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, rolesData: rolesData, countData: countData, limit: limit, page: page, onChangePage: onChangePage, onChangeLimit: onChangeLimit, permissionsRows: permissionsRows, setOpenModalEdit: setOpenModalEdit, setIsEdit: setIsEdit, setOpenModalCreate: handleOpenCreateModal, setFiltersApplied: setFiltersApplied, setSearchQuery: setSearchQuery })] }));
};
